import { computed, ref, watch } from 'vue';
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-ea7d3b30"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "drawer-title"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "客诉处理详情", -1));
const _hoisted_3 = {
  key: 0,
  class: "drawer-body"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "warning-alert__icon"
}, "!", -1));
const _hoisted_5 = {
  class: "warning-alert__content"
};
const _hoisted_6 = {
  class: "warning-alert__title"
};
const _hoisted_7 = {
  class: "warning-alert__reason"
};
const _hoisted_8 = {
  key: 0
};
const _hoisted_9 = {
  class: "detail-grid"
};
const _hoisted_10 = {
  class: "complaint-detail-card"
};
const _hoisted_11 = {
  class: "section-title"
};
const _hoisted_12 = {
  class: "info-grid"
};
const _hoisted_13 = ["title"];
const _hoisted_14 = ["onClick"];
const _hoisted_15 = {
  class: "complaint-detail-card"
};
const _hoisted_16 = {
  class: "section-title"
};
const _hoisted_17 = {
  class: "complaint-row"
};
const _hoisted_18 = {
  class: "complaint-row"
};
const _hoisted_19 = {
  class: "complaint-times"
};
const _hoisted_20 = {
  class: "complaint-row"
};
const _hoisted_21 = {
  class: "complaint-full"
};
const _hoisted_22 = {
  class: "history-card"
};
const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "section-title"
}, "协商历史", -1));
const _hoisted_24 = {
  class: "history-head"
};
const _hoisted_25 = {
  class: "his-time"
};
const _hoisted_26 = {
  class: "history-content"
};
const _hoisted_27 = {
  class: "history-content__text"
};
const _hoisted_28 = {
  key: 0,
  class: "history-media"
};
const _hoisted_29 = ["onClick"];
const _hoisted_30 = {
  key: 0,
  class: "reply-editor"
};
const _hoisted_31 = {
  class: "reply-editor__header"
};
const _hoisted_32 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "回复用户", -1));
const _hoisted_33 = {
  key: 0,
  class: "reply-editor__files"
};
const _hoisted_34 = ["onClick"];
const _hoisted_35 = {
  class: "reply-editor__tools"
};
const _hoisted_36 = {
  class: "reply-editor__left-tools"
};
const _hoisted_37 = {
  class: "reply-template-dropdown"
};
const _hoisted_38 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "reply-template-dropdown__header"
}, "选择快捷回复", -1));
const _hoisted_39 = {
  class: "reply-template-menu__title"
};
const _hoisted_40 = {
  class: "reply-template-menu__content"
};
const _hoisted_41 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "reply-editor__limit"
}, "最多4张", -1));
const _hoisted_42 = {
  class: "drawer-footer"
};
import dayjs from 'dayjs';
import { CloseOutlined, CopyOutlined, ExclamationCircleOutlined, LoadingOutlined, PictureOutlined, ShoppingCartOutlined } from '@ant-design/icons-vue';
import { awaitWrap } from '@/common';
import { queryComplaintMediaPreview } from '@/api/wechatComplaint';
export default /*#__PURE__*/_defineComponent({
  __name: 'DetailDrawer',
  props: {
    open: {
      type: Boolean
    },
    loading: {
      type: Boolean
    },
    complaint: null,
    historyList: null,
    orderInfoList: null,
    replyContent: null,
    replyFiles: null,
    replyTemplates: null,
    resendText: null,
    resending: {
      type: Boolean
    },
    replyLoading: {
      type: Boolean
    },
    submitLoading: {
      type: Boolean
    },
    refundDisabledTip: null,
    complaintStateMap: null,
    refundStateMap: null,
    problemTypeMap: null,
    toMoney: null,
    beforeUploadImage: null,
    canUpdate: {
      type: Boolean
    }
  },
  emits: ["close", "reply", "resend", "refund", "reject", "copy", "fill-template", "paste-image", "remove-file", "update:replyContent"],
  setup(__props, {
    emit
  }) {
    const props = __props;
    const reshipActionMap = {
      '10': {
        label: '复送中',
        color: 'blue'
      },
      '20': {
        label: '复送完成',
        color: 'green'
      }
    };
    const resendActionMeta = computed(() => {
      var _props$complaint;
      const reshipStatus = (_props$complaint = props.complaint) === null || _props$complaint === void 0 ? void 0 : _props$complaint.reshipStatus;
      return reshipActionMap[reshipStatus == null ? '' : String(reshipStatus)];
    });
    const resendActionText = computed(() => {
      var _resendActionMeta$val;
      return ((_resendActionMeta$val = resendActionMeta.value) === null || _resendActionMeta$val === void 0 ? void 0 : _resendActionMeta$val.label) || props.resendText;
    });
    const resendActionTip = computed(() => {
      var _resendActionMeta$val2, _props$complaint2;
      return ((_resendActionMeta$val2 = resendActionMeta.value) === null || _resendActionMeta$val2 === void 0 ? void 0 : _resendActionMeta$val2.label) || ((_props$complaint2 = props.complaint) === null || _props$complaint2 === void 0 || (_props$complaint2 = _props$complaint2.actions) === null || _props$complaint2 === void 0 || (_props$complaint2 = _props$complaint2.resend) === null || _props$complaint2 === void 0 ? void 0 : _props$complaint2.disabledReason);
    });
    const resendActionClass = computed(() => resendActionMeta.value ? `refund-action-btn refund-action-btn--${resendActionMeta.value.color}` : '');
    const resendActionDisabled = computed(() => {
      var _props$complaint3;
      return props.resending || !!resendActionMeta.value || ((_props$complaint3 = props.complaint) === null || _props$complaint3 === void 0 || (_props$complaint3 = _props$complaint3.actions) === null || _props$complaint3 === void 0 || (_props$complaint3 = _props$complaint3.resend) === null || _props$complaint3 === void 0 ? void 0 : _props$complaint3.disabled);
    });
    const refundActionMeta = computed(() => {
      var _props$complaint4;
      const refundState = (_props$complaint4 = props.complaint) === null || _props$complaint4 === void 0 ? void 0 : _props$complaint4.refundState;
      const key = refundState == null ? '' : String(refundState);
      if (!['20', '50'].includes(key)) return null;
      return props.refundStateMap[key];
    });
    const refundActionText = computed(() => {
      var _refundActionMeta$val;
      return ((_refundActionMeta$val = refundActionMeta.value) === null || _refundActionMeta$val === void 0 ? void 0 : _refundActionMeta$val.label) || '同意退款';
    });
    const refundActionTip = computed(() => {
      var _refundActionMeta$val2;
      return ((_refundActionMeta$val2 = refundActionMeta.value) === null || _refundActionMeta$val2 === void 0 ? void 0 : _refundActionMeta$val2.label) || props.refundDisabledTip;
    });
    const refundActionClass = computed(() => refundActionMeta.value ? `refund-action-btn refund-action-btn--${refundActionMeta.value.color}` : '');
    const refundActionDisabled = computed(() => {
      var _props$complaint5;
      return !!refundActionMeta.value || !!props.refundDisabledTip || ((_props$complaint5 = props.complaint) === null || _props$complaint5 === void 0 || (_props$complaint5 = _props$complaint5.actions) === null || _props$complaint5 === void 0 || (_props$complaint5 = _props$complaint5.approveRefund) === null || _props$complaint5 === void 0 ? void 0 : _props$complaint5.disabled);
    });
    const operateTypeMap = {
      USER_CREATE_COMPLAINT: '用户提交投诉',
      USER_CONTINUE_COMPLAINT: '用户继续投诉',
      USER_RESPONSE: '用户留言',
      PLATFORM_RESPONSE: '平台留言',
      MERCHANT_RESPONSE: '商户留言',
      MERCHANT_CONFIRM_COMPLETE: '商户申请结单',
      USER_CREATE_COMPLAINT_SYSTEM_MESSAGE: '用户提交投诉系统通知',
      COMPLAINT_FULL_REFUNDED_SYSTEM_MESSAGE: '投诉单发起全额退款系统通知',
      USER_CONTINUE_COMPLAINT_SYSTEM_MESSAGE: '用户继续投诉系统通知',
      USER_REVOKE_COMPLAINT: '用户主动撤诉',
      USER_COMFIRM_COMPLAINT: '用户确认投诉解决',
      PLATFORM_HELP_APPLICATION: '平台催办',
      USER_APPLY_PLATFORM_HELP: '用户申请平台协助',
      MERCHANT_APPROVE_REFUND: '商户同意退款申请',
      MERCHANT_REFUSE_RERUND: '商户拒绝退款申请',
      USER_SUBMIT_SATISFACTION: '用户提交满意度调查结果',
      SERVICE_ORDER_CANCEL: '服务订单已取消',
      SERVICE_ORDER_COMPLETE: '服务订单已完成',
      COMPLAINT_PARTIAL_REFUNDED_SYSTEM_MESSAGE: '投诉单发起部分退款系统通知',
      COMPLAINT_REFUND_RECEIVED_SYSTEM_MESSAGE: '投诉单退款到账系统通知',
      COMPLAINT_ENTRUSTED_REFUND_SYSTEM_MESSAGE: '投诉单受托退款系统通知',
      USER_APPLY_PLATFORM_SERVICE: '用户申请平台协助',
      USER_CANCEL_PLATFORM_SERVICE: '用户取消平台协助',
      PLATFORM_SERVICE_FINISHED: '客服结束平台协助',
      USER_CLICK_RESPONSE: '用户因点击产生留言'
    };
    // 完结类阶段：商户申请结单 / 服务订单已完成 —— 时间轴 icon 走绿色
    const COMPLETE_OPERATE_TYPES = new Set(['MERCHANT_CONFIRM_COMPLETE', 'SERVICE_ORDER_COMPLETE']);
    const isCompleteOperate = type => !!type && COMPLETE_OPERATE_TYPES.has(type);
    const historyPreviewVisibleIndex = ref(null);
    const setHistoryPreviewVisible = (index, visible) => {
      historyPreviewVisibleIndex.value = visible ? index : null;
    };
    const resolvedPreviewUrls = ref({});
    const previewLoadingIndexes = ref([]);
    const handleClickPreview = async index => {
      var _item$imageList, _props$complaint$comp, _props$complaint6;
      const item = props.historyList[index];
      if (!(item !== null && item !== void 0 && (_item$imageList = item.imageList) !== null && _item$imageList !== void 0 && _item$imageList.length)) return;
      if (resolvedPreviewUrls.value[index]) {
        historyPreviewVisibleIndex.value = index;
        return;
      }
      previewLoadingIndexes.value = [...previewLoadingIndexes.value, index];
      const complaintMainId = (_props$complaint$comp = (_props$complaint6 = props.complaint) === null || _props$complaint6 === void 0 ? void 0 : _props$complaint6.complaintMainId) !== null && _props$complaint$comp !== void 0 ? _props$complaint$comp : '';
      const results = await Promise.all(item.imageList.map(async url => {
        var _res$data;
        const mediaId = decodeURIComponent(url.split('/').pop() || '');
        const [, res] = await awaitWrap(queryComplaintMediaPreview({
          mediaId,
          complaintMainId
        }));
        return (res === null || res === void 0 || (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.previewUrl) || url;
      }));
      resolvedPreviewUrls.value = {
        ...resolvedPreviewUrls.value,
        [index]: results
      };
      previewLoadingIndexes.value = previewLoadingIndexes.value.filter(i => i !== index);
      historyPreviewVisibleIndex.value = index;
    };
    watch(() => props.historyList, () => {
      resolvedPreviewUrls.value = {};
      previewLoadingIndexes.value = [];
      historyPreviewVisibleIndex.value = null;
    });
    const formatOperateTime = value => value ? dayjs(value).format('YYYY-MM-DD HH:mm:ss') : '-';
    return (_ctx, _cache) => {
      const _component_a_tag = _resolveComponent("a-tag");
      const _component_svg_icon = _resolveComponent("svg-icon");
      const _component_a_image = _resolveComponent("a-image");
      const _component_a_image_preview_group = _resolveComponent("a-image-preview-group");
      const _component_a_timeline_item = _resolveComponent("a-timeline-item");
      const _component_a_timeline = _resolveComponent("a-timeline");
      const _component_a_textarea = _resolveComponent("a-textarea");
      const _component_a_button = _resolveComponent("a-button");
      const _component_a_menu_item = _resolveComponent("a-menu-item");
      const _component_a_menu = _resolveComponent("a-menu");
      const _component_a_dropdown = _resolveComponent("a-dropdown");
      const _component_a_upload = _resolveComponent("a-upload");
      const _component_a_tooltip = _resolveComponent("a-tooltip");
      const _component_a_spin = _resolveComponent("a-spin");
      const _component_a_drawer = _resolveComponent("a-drawer");
      return _openBlock(), _createBlock(_component_a_drawer, {
        "root-class-name": "wechat-complaint-drawer",
        open: __props.open,
        width: "900px",
        placement: "right",
        closable: false,
        "mask-closable": true,
        onClose: _cache[9] || (_cache[9] = $event => emit('close'))
      }, _createSlots({
        title: _withCtx(() => {
          var _props$complaintStat;
          return [_createElementVNode("div", _hoisted_1, [_hoisted_2, __props.complaint ? (_openBlock(), _createBlock(_component_a_tag, {
            key: 0,
            color: (_props$complaintStat = __props.complaintStateMap[__props.complaint.complaintState]) === null || _props$complaintStat === void 0 ? void 0 : _props$complaintStat.color
          }, {
            default: _withCtx(() => {
              var _props$complaintStat2;
              return [_createTextVNode(_toDisplayString(((_props$complaintStat2 = __props.complaintStateMap[__props.complaint.complaintState]) === null || _props$complaintStat2 === void 0 ? void 0 : _props$complaintStat2.label) || __props.complaint.complaintState), 1)];
            }),
            _: 1
          }, 8, ["color"])) : _createCommentVNode("", true), _createVNode(_unref(CloseOutlined), {
            class: "drawer-close",
            onClick: _cache[0] || (_cache[0] = $event => emit('close'))
          })])];
        }),
        default: _withCtx(() => [_createVNode(_component_a_spin, {
          spinning: __props.loading
        }, {
          default: _withCtx(() => {
            var _props$problemTypeMa, _props$complaint$act;
            return [__props.complaint ? (_openBlock(), _createElementBlock("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.complaint.warnings || [], warning => {
              return _openBlock(), _createElementBlock("div", {
                key: warning.type,
                class: _normalizeClass(["warning-alert", warning.type === 'refundFailed' ? 'warning-alert--error' : 'warning-alert--warning'])
              }, [_hoisted_4, _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, _toDisplayString(warning.title), 1), _createElementVNode("div", _hoisted_7, [_createTextVNode(_toDisplayString(warning.reason), 1), warning.strongReason ? (_openBlock(), _createElementBlock("strong", _hoisted_8, _toDisplayString(warning.strongReason), 1)) : _createCommentVNode("", true), _createTextVNode(_toDisplayString(warning.reasonSuffix), 1)])])], 2);
            }), 128)), _createElementVNode("div", _hoisted_9, [_createElementVNode("section", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createVNode(_unref(ShoppingCartOutlined), {
              class: "section-icon section-icon--order"
            }), _createTextVNode(" 订单信息 ")]), _createElementVNode("div", _hoisted_12, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.orderInfoList, item => {
              return _openBlock(), _createElementBlock("div", {
                key: item.label,
                class: "info-item"
              }, [_createElementVNode("span", null, _toDisplayString(item.label), 1), _createElementVNode("strong", {
                class: _normalizeClass({
                  danger: item.danger
                }),
                title: item.value
              }, _toDisplayString(item.value || '-'), 11, _hoisted_13), item.copy ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "copy-btn",
                onClick: $event => emit('copy', item.value)
              }, [_createVNode(_unref(CopyOutlined), {
                class: "copy-icon"
              })], 8, _hoisted_14)) : _createCommentVNode("", true)]);
            }), 128))])]), _createElementVNode("section", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_createVNode(_unref(ExclamationCircleOutlined), {
              class: "section-icon section-icon--complaint"
            }), _createTextVNode(" 投诉详情 "), __props.complaint.problemTypeLabel || __props.complaint.problemType ? (_openBlock(), _createBlock(_component_a_tag, {
              key: 0,
              class: "type-tag",
              color: (_props$problemTypeMa = __props.problemTypeMap[__props.complaint.problemType]) === null || _props$problemTypeMa === void 0 ? void 0 : _props$problemTypeMa.color
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(__props.complaint.problemTypeLabel || __props.complaint.problemType), 1)]),
              _: 1
            }, 8, ["color"])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_17, "问题描述：" + _toDisplayString(__props.complaint.problemDescription || '-'), 1), _createElementVNode("div", _hoisted_18, [_createTextVNode(" 联系电话： "), _createElementVNode("span", {
              class: "copyable",
              onClick: _cache[1] || (_cache[1] = $event => emit('copy', __props.complaint.payerPhone))
            }, _toDisplayString(__props.complaint.payerPhone || '-'), 1), _createElementVNode("span", _hoisted_19, "（共投诉 " + _toDisplayString(__props.complaint.userComplaintTimes || 0) + " 次）", 1)]), _createElementVNode("div", _hoisted_20, "申退金额：" + _toDisplayString(__props.complaint.applyRefundAmount || '-'), 1), _createElementVNode("pre", _hoisted_21, _toDisplayString(__props.complaint.complaintDetail || '-'), 1)])]), _createElementVNode("section", _hoisted_22, [_hoisted_23, _createVNode(_component_a_timeline, null, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.historyList, (item, index) => {
                return _openBlock(), _createBlock(_component_a_timeline_item, {
                  key: `${item.operateTime}-${item.operateType}-${index}`
                }, {
                  dot: _withCtx(() => [_createElementVNode("div", {
                    class: _normalizeClass(["timeline-dot", {
                      done: isCompleteOperate(item.operateType)
                    }])
                  }, [_createVNode(_component_svg_icon, {
                    "icon-class": item.operator === '投诉人' ? 'userIcon' : 'sys'
                  }, null, 8, ["icon-class"])], 2)]),
                  default: _withCtx(() => {
                    var _item$imageList2;
                    return [_createElementVNode("div", _hoisted_24, [_createElementVNode("strong", null, _toDisplayString(item.operator), 1), _createVNode(_component_a_tag, null, {
                      default: _withCtx(() => [_createTextVNode(_toDisplayString(operateTypeMap[item.operateType] || item.operateType), 1)]),
                      _: 2
                    }, 1024), _createElementVNode("span", _hoisted_25, _toDisplayString(formatOperateTime(item.operateTime)), 1)]), _createElementVNode("div", _hoisted_26, [_createElementVNode("pre", _hoisted_27, _toDisplayString(item.operateDetails || '-'), 1), (_item$imageList2 = item.imageList) !== null && _item$imageList2 !== void 0 && _item$imageList2.length ? (_openBlock(), _createElementBlock("span", _hoisted_28, [_createElementVNode("span", {
                      class: "history-media__trigger",
                      onClick: $event => handleClickPreview(index)
                    }, [previewLoadingIndexes.value.includes(index) ? (_openBlock(), _createBlock(_unref(LoadingOutlined), {
                      key: 0
                    })) : (_openBlock(), _createBlock(_unref(PictureOutlined), {
                      key: 1
                    })), _createTextVNode(" 查看附图 (" + _toDisplayString(item.imageList.length) + ") ", 1)], 8, _hoisted_29), _createVNode(_component_a_image_preview_group, {
                      preview: {
                        visible: historyPreviewVisibleIndex.value === index,
                        onVisibleChange: visible => setHistoryPreviewVisible(index, visible)
                      }
                    }, {
                      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(resolvedPreviewUrls.value[index] || [], (url, imgIndex) => {
                        return _openBlock(), _createBlock(_component_a_image, {
                          key: imgIndex,
                          src: url,
                          style: {
                            display: 'none'
                          }
                        }, null, 8, ["src"]);
                      }), 128))]),
                      _: 2
                    }, 1032, ["preview"])])) : _createCommentVNode("", true)])];
                  }),
                  _: 2
                }, 1024);
              }), 128))]),
              _: 1
            }), __props.canUpdate ? (_openBlock(), _createElementBlock("div", _hoisted_30, [_createElementVNode("div", _hoisted_31, [_createVNode(_component_svg_icon, {
              "icon-class": "replay",
              "class-name": "reply-editor__icon"
            }), _hoisted_32]), _createVNode(_component_a_textarea, {
              value: __props.replyContent,
              maxlength: 200,
              "auto-size": {
                minRows: 4,
                maxRows: 6
              },
              placeholder: "请输入回复内容，至少10个字...",
              "onUpdate:value": _cache[2] || (_cache[2] = $event => emit('update:replyContent', $event)),
              onPaste: _cache[3] || (_cache[3] = $event => emit('paste-image', $event))
            }, null, 8, ["value"]), __props.replyFiles.length ? (_openBlock(), _createElementBlock("div", _hoisted_33, [_createVNode(_component_a_image_preview_group, null, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.replyFiles, file => {
                return _openBlock(), _createElementBlock("div", {
                  key: file.uid,
                  class: "reply-editor__thumb"
                }, [_createVNode(_component_a_image, {
                  src: file.url,
                  width: 56,
                  height: 56
                }, null, 8, ["src"]), _createElementVNode("button", {
                  class: "reply-editor__remove",
                  type: "button",
                  onClick: $event => emit('remove-file', file)
                }, [_createVNode(_component_svg_icon, {
                  "icon-class": "close",
                  "class-name": "reply-editor__remove-icon"
                })], 8, _hoisted_34)]);
              }), 128))]),
              _: 1
            })])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_35, [_createElementVNode("div", _hoisted_36, [_createVNode(_component_a_dropdown, {
              placement: "topLeft",
              trigger: ['click']
            }, {
              overlay: _withCtx(() => [_createElementVNode("div", _hoisted_37, [_hoisted_38, _createVNode(_component_a_menu, {
                class: "reply-template-menu",
                onClick: _cache[4] || (_cache[4] = item => emit('fill-template', item.key))
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.replyTemplates, item => {
                  return _openBlock(), _createBlock(_component_a_menu_item, {
                    key: item.content
                  }, {
                    default: _withCtx(() => [_createElementVNode("div", _hoisted_39, _toDisplayString(item.title), 1), _createElementVNode("div", _hoisted_40, _toDisplayString(item.content), 1)]),
                    _: 2
                  }, 1024);
                }), 128))]),
                _: 1
              })])]),
              default: _withCtx(() => [_createVNode(_component_a_button, {
                size: "small",
                type: "text"
              }, {
                icon: _withCtx(() => [_createVNode(_component_svg_icon, {
                  "icon-class": "replay",
                  "class-name": "reply-editor__tool-icon"
                })]),
                default: _withCtx(() => [_createTextVNode(" 快捷模板 ")]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_a_upload, {
              "before-upload": __props.beforeUploadImage,
              "show-upload-list": false,
              accept: "image/*"
            }, {
              default: _withCtx(() => [_createVNode(_component_a_button, {
                size: "small",
                type: "text",
                disabled: __props.replyFiles.length >= 4
              }, {
                icon: _withCtx(() => [_createVNode(_component_svg_icon, {
                  "icon-class": "upload_stencil",
                  "class-name": "reply-editor__tool-icon"
                })]),
                default: _withCtx(() => [_createTextVNode(" 添加图片 "), _hoisted_41]),
                _: 1
              }, 8, ["disabled"])]),
              _: 1
            }, 8, ["before-upload"])]), _createVNode(_component_a_tooltip, {
              title: (_props$complaint$act = __props.complaint.actions) === null || _props$complaint$act === void 0 || (_props$complaint$act = _props$complaint$act.reply) === null || _props$complaint$act === void 0 ? void 0 : _props$complaint$act.disabledReason
            }, {
              default: _withCtx(() => {
                var _props$complaint$act2, _props$complaint$act3;
                return [((_props$complaint$act2 = __props.complaint.actions) === null || _props$complaint$act2 === void 0 || (_props$complaint$act2 = _props$complaint$act2.reply) === null || _props$complaint$act2 === void 0 ? void 0 : _props$complaint$act2.show) !== false ? (_openBlock(), _createBlock(_component_a_button, {
                  key: 0,
                  type: "primary",
                  loading: __props.replyLoading,
                  disabled: __props.replyLoading || __props.replyContent.length < 10 || ((_props$complaint$act3 = __props.complaint.actions) === null || _props$complaint$act3 === void 0 || (_props$complaint$act3 = _props$complaint$act3.reply) === null || _props$complaint$act3 === void 0 ? void 0 : _props$complaint$act3.disabled),
                  onClick: _cache[5] || (_cache[5] = $event => emit('reply'))
                }, {
                  default: _withCtx(() => [_createTextVNode(" 发送并同步 ")]),
                  _: 1
                }, 8, ["loading", "disabled"])) : _createCommentVNode("", true)];
              }),
              _: 1
            }, 8, ["title"])])])) : _createCommentVNode("", true)])])) : _createCommentVNode("", true)];
          }),
          _: 1
        }, 8, ["spinning"])]),
        _: 2
      }, [__props.complaint && __props.canUpdate ? {
        name: "footer",
        fn: _withCtx(() => {
          var _props$complaint$act6;
          return [_createElementVNode("div", _hoisted_42, [_createVNode(_component_a_tooltip, {
            title: _unref(resendActionTip)
          }, {
            default: _withCtx(() => {
              var _props$complaint$act4;
              return [((_props$complaint$act4 = __props.complaint.actions) === null || _props$complaint$act4 === void 0 || (_props$complaint$act4 = _props$complaint$act4.resend) === null || _props$complaint$act4 === void 0 ? void 0 : _props$complaint$act4.show) !== false ? (_openBlock(), _createBlock(_component_a_button, {
                key: 0,
                loading: __props.resending,
                class: _normalizeClass(_unref(resendActionClass)),
                disabled: _unref(resendActionDisabled),
                onClick: _cache[6] || (_cache[6] = $event => emit('resend'))
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(resendActionText)), 1)]),
                _: 1
              }, 8, ["loading", "class", "disabled"])) : _createCommentVNode("", true)];
            }),
            _: 1
          }, 8, ["title"]), _createVNode(_component_a_tooltip, {
            title: _unref(refundActionTip)
          }, {
            default: _withCtx(() => {
              var _props$complaint$act5;
              return [((_props$complaint$act5 = __props.complaint.actions) === null || _props$complaint$act5 === void 0 || (_props$complaint$act5 = _props$complaint$act5.approveRefund) === null || _props$complaint$act5 === void 0 ? void 0 : _props$complaint$act5.show) !== false ? (_openBlock(), _createBlock(_component_a_button, {
                key: 0,
                danger: !_unref(refundActionMeta),
                class: _normalizeClass(_unref(refundActionClass)),
                disabled: _unref(refundActionDisabled),
                onClick: _cache[7] || (_cache[7] = $event => emit('refund'))
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(refundActionText)), 1)]),
                _: 1
              }, 8, ["danger", "class", "disabled"])) : _createCommentVNode("", true)];
            }),
            _: 1
          }, 8, ["title"]), _createVNode(_component_a_tooltip, {
            title: (_props$complaint$act6 = __props.complaint.actions) === null || _props$complaint$act6 === void 0 || (_props$complaint$act6 = _props$complaint$act6.complete) === null || _props$complaint$act6 === void 0 ? void 0 : _props$complaint$act6.disabledReason
          }, {
            default: _withCtx(() => {
              var _props$complaint$act7, _props$complaint$act8;
              return [((_props$complaint$act7 = __props.complaint.actions) === null || _props$complaint$act7 === void 0 || (_props$complaint$act7 = _props$complaint$act7.complete) === null || _props$complaint$act7 === void 0 ? void 0 : _props$complaint$act7.show) !== false ? (_openBlock(), _createBlock(_component_a_button, {
                key: 0,
                loading: __props.submitLoading,
                disabled: __props.submitLoading || ((_props$complaint$act8 = __props.complaint.actions) === null || _props$complaint$act8 === void 0 || (_props$complaint$act8 = _props$complaint$act8.complete) === null || _props$complaint$act8 === void 0 ? void 0 : _props$complaint$act8.disabled),
                onClick: _cache[8] || (_cache[8] = $event => emit('reject'))
              }, {
                default: _withCtx(() => [_createTextVNode(" 处理完成 ")]),
                _: 1
              }, 8, ["loading", "disabled"])) : _createCommentVNode("", true)];
            }),
            _: 1
          }, 8, ["title"])])];
        }),
        key: "0"
      } : undefined]), 1032, ["open"]);
    };
  }
});